import React from 'react';
import styles from '@/styles/components/question-builders/base/Textarea.module.css';
import {
  TemplateContentElement,
  TemplateContentElementData,
} from './TemplateContentElement';

export interface TextareaData extends TemplateContentElementData {
  info?: string;
}

export const Textarea: React.FC<TextareaData> = props => {
  const isEditable = props.templateType === 'template';
  const [parentFocus, setParentFocus] = React.useState(false);
  return (
    <div className={styles.textAreaContainer}>
      <div
        className={`${styles.textContainer} ${
          isEditable ? styles.editableContainer : ''
        }`}
        onClick={() => setParentFocus(true)}
        onBlur={() => setParentFocus(false)}
      >
        <TemplateContentElement {...props} parentFocus={parentFocus} />
      </div>
      {props.info && <span className={styles.info}>{props.info}</span>}
    </div>
  );
};
